import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import { Toaster } from './ui/sonner';

export const Layout = ({ onLogout }) => {
  return (
    <div className="xp-app">
      {/* Orb effects (decorative) */}
      <div className="orb orb-1" aria-hidden="true"></div>
      <div className="orb orb-2" aria-hidden="true"></div>

      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-50 focus:bg-seo focus:text-white focus:px-4 focus:py-2 focus:rounded"
      >
        Skip to main content
      </a>
      <Sidebar onLogout={onLogout} />
      <main className="xp-main" id="main-content" tabIndex={-1}>
        <TopBar />
        <div className="xp-page">
          <Outlet />
        </div>
      </main>
      <Toaster position="top-right" />
    </div>
  );
};

export default Layout;
